import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AdminDashboard from './pages/admin-dashboard';
import AdminLogin from './pages/admin-login';
import AdminRegistrations from './pages/admin-registrations';
import TeamRegistrationForm from './pages/team-registration-form';
import DocumentUploadCenter from './pages/document-upload-center';
import RegistrationDashboard from './pages/registration-dashboard';
import MobileAuthentication from './pages/mobile-authentication';
import DeclarationAndSubmission from './pages/declaration-and-submission';
import AdminCommunicationCenter from './pages/admin-communication-center';
import DataExportDashboard from './pages/data-export-dashboard';
import RegistrationDetailView from './pages/registration-detail-view';
import TermsAndConditions from './pages/terms-and-conditions';
import SuperAdminPlayerEditor from './pages/super-admin-player-editor';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<MobileAuthentication />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/admin-registrations" element={<AdminRegistrations />} />
        <Route path="/team-registration-form" element={<TeamRegistrationForm />} />
        <Route path="/document-upload-center" element={<DocumentUploadCenter />} />
        <Route path="/registration-dashboard" element={<RegistrationDashboard />} />
        <Route path="/mobile-authentication" element={<MobileAuthentication />} />
        <Route path="/declaration-and-submission" element={<DeclarationAndSubmission />} />
        <Route path="/admin-communication-center" element={<AdminCommunicationCenter />} />
        <Route path="/data-export-dashboard" element={<DataExportDashboard />} />
        <Route path="/registration-detail-view" element={<RegistrationDetailView />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/super-admin-player-editor" element={<SuperAdminPlayerEditor />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
